module.exports = __webpack_public_path__ + "img/9788983923981.eb65dd5d.jpg";